/**
 * GiftCardDetailBody — the summary + ledger layout (BON-223): a two-column
 * grid on desktop, a single stacked column on phone and tablet — mirroring
 * the design's own `mobile = device !== 'desktop'` split, where only desktop
 * gets the side-by-side grid.
 */
import { GiftCardLedgerCard } from './GiftCardLedgerCard';
import { GiftCardSummaryCard } from './GiftCardSummaryCard';
import type { GiftCardDetail } from './giftCardTypes';

export function GiftCardDetailBody({
  card,
  isDesktop,
}: {
  card: GiftCardDetail;
  isDesktop: boolean;
}) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isDesktop ? 'minmax(0,1fr) minmax(0,1.35fr)' : '1fr',
        gap: 16,
        alignItems: 'start',
      }}
    >
      <GiftCardSummaryCard card={card} />
      <GiftCardLedgerCard card={card} />
    </div>
  );
}
